const CONST = {
    JACKPOT:{
      PLATINUM_MULTIPLIER: 5000,
      GOLD_MULTIPLIER: 150,
      SILVER_MULTIPLIER: 50,
      BRONZE_MULTIPLIER: 20,
    },
    SYMBOLS: {
        WILD: "9",
        COIN: "10"
    },
    COLUMNS: 5,
    ROWS: 3
}

export {CONST}